<template>
  <fragment>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn
          width="100%"
          :class="['rounded-lg']"
          @click="openDescriptionModal"
        >
          <v-icon left v-if="descriptionIsNotEmpty" color="green"
            >mdi-text-box-check-outline</v-icon
          >
          <v-icon left v-else>mdi-text-box-remove-outline</v-icon>
          <span class="desc">
            {{ $t("events.event-config.insert-description-here") }}
          </span>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseSelect
          required
          tabindex="1"
          label="Status"
          item-text="value"
          item-value="key"
          :placeholder="$t('events.select-status')"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.status_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseSelect
          required
          tabindex="2"
          :label="$t('events.category')"
          item-text="descricao"
          item-value="idcategoria"
          :placeholder="$t('events.select-category')"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.categorias_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.event-date-hour')"
          type="datetime"
          v-mask="'##/##/#### ##:##'"
          placeholder="dd/mm/aaaa hh:mm"
          append-icon="mdi-calendar"
          persistent-hint
          :rules="dateRequired"
          :hint="apresentationDateExplain"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao
          "
        />
      </v-col>
    </v-row>
    <v-row
      v-if="
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== 'INGRESSO'
      "
      class="mb-3"
    >
      <v-col cols="12" sm="6">
        <BaseMoneyField
          :required="!isCourtesyProduct"
          tabindex="3"
          :label="$t('events.event-config.price')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>

    <label style="font-weight: 600; font-size: 14px">{{
      $t("events.event-config.event-address")
    }}</label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.event-location')"
          :placeholder="$t('events.event-config.insert-event-location')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :items="$config.paises.result"
          :placeholder="$t('events.event-config.select-country')"
          :label="$t('events.event-config.select-country')"
          required
          chips
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
          :loading="$config.loading_paises"
          item-text="dsc_lang"
          item-value="iso_full"
          needSelection
        >
          <template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item">
              <template v-if="item ? (paises = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :items="$config.estados.result"
          :label="$t('events.event-config.state')"
          :placeholder="$t('events.event-config.select-state')"
          chips
          required
          hide-details
          needSelection
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
          :loading="$config.loading_estados"
          item-text="dsc_lang"
          item-value="iso_full"
        >
          <template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item.selected">
              <template v-if="item ? (estados = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.city')"
          item-text="dsc_lang"
          item-value="dsc_lang"
          :placeholder="$t('events.event-config.select-city')"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6" v-if="isAdmin">
        <v-checkbox
          :label="$t('events.event-config.show-accomodation-map')"
          class="my-0"
          hide-details
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.mapa_hospedagem
          "
        ></v-checkbox>
      </v-col>
    </v-row>
    <label style="font-weight: 600; font-size: 14px">
      {{ $t("events.event-config.complementary-info") }}
    </label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6" v-if="isNotACourtesyProduct">
        <BaseSelect
          required
          :label="$t('events.channel-sales')"
          :placeholder="$t('events.select-channel-sales')"
          item-text="value"
          item-value="key"
          :items="filtredSalesChannel()"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.canal_venda"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseSelect
          clearable
          label="Tag"
          :placeholder="$t('events.event-config.select-tags')"
          item-text="key"
          item-value="value"
          :items="tags"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tags"
          @click:clear="$produtos_gerenciar.cadastro.dados_cadastrais.tags = []"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.limit-ticket-per-consumer')"
          placeholder="Ex: 5"
          type="number"
          min="1"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf
          "
        />
      </v-col>
      <v-col v-if="isNotACourtesyProduct && isAdmin" cols="12" sm="6">
        <v-checkbox
          hide-details
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          :label="$t('events.event-config.highlight-product')"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgba(0, 0, 0, 0.377)"
          active-class="active-class"
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <ModalTraducoes />
    <DescriptionProduct />
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import ModalTraducoes from "@/components/global/modal-traducoes.vue";
import DescriptionProduct from "@/components/produtos/gerenciar/DescriptionProduct.vue";
import { mapGetters } from "vuex";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import { filtredSalesChannel } from "@/utils";

const { products, formRules } = mixins;

export default {
  name: "CommonProduct",
  mixins: [products, formRules],
  components: {
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    ModalTraducoes,
    DescriptionProduct,
    BaseMoneyField,
  },
  data: () => ({
    filtredSalesChannel,
    descricao: "",
    descritivo: "",
    paises: [],
    estados: [],
    cidades: [],
  }),
  methods: {
    openDescriptionModal() {
      this.$produtos_gerenciar.descriptionModal = true;
    },
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    apresentationDateExplain() {
      return `ℹ️ ${this.$t("events.event-config.event-date-hour-info")}`;
    },
    dateRequired() {
      const courtesyAndTicket =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA";
      const someProductWithOptionDate =
        this.$produtos_gerenciar.cadastro.variacoes.opcoes.some(item => {
          return item.tipo === "DATA";
        });

      return courtesyAndTicket && !someProductWithOptionDate
        ? [this.rules.required]
        : [];
    },
    descriptionIsNotEmpty() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo !== ""
      );
    },
    isCourtesyProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA"
      );
    },
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
    limitedTickets() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .limitarIngressos;
    },
    isNotACourtesyProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "CORTESIA"
      );
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br": function (
      e
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        e.substring(0, 2).toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.tipo": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        e.substring(0, 2) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
      if (e === "VOUCHER" || e === "RECARGA") {
        this.descricao = "Produto";
        this.descritivo = "Descrição";
        this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote = false;
      } else if (e === "INGRESSO" || e === "CORTESIA") {
        this.descricao = "Evento";
        this.descritivo = this.$t("events.event-description");
      } else {
        this.descricao = "Título do Produto";
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.categoria": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        e.substring(0, 2).toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao"(e) {
      if (e == "") {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao =
          null;
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos"(e) {
      if (e == false) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf = 0;
      }
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.canal_venda === "") {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.canal_venda =
        "ECOMMERCE;IFRAME;LINK";
    }
  },
  destroyed() {
    this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo_pt_br = false;
  },
};
</script>
<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.description-product {
  border: 2px solid red !important;
  background-color: white !important;
}
.desc::after {
  content: "*";
  color: red;
}
</style>
